import React, { useState } from "react";
import logo from "../assets/logo.png";
import { TextField, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import Swal from "sweetalert2";
import { httpService } from "../httpService";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
function ResetPassword() {
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const { id } = useParams();

  const resetPassword = (e) => {
    e.preventDefault();
    if (error) {
      return;
    }
    Swal.fire({
      icon: "question",
      title: "Update Password",
      text: "Do you wish to update your password?",
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        const { data, error } = await httpService.post("updatepassword", {
          examiner: id,
          password,
        });

        if (data) {
          window.location.assign("/");
        }
        if (error) {
          toast.error(error);
        }
        setLoading(false);
      }
    });
  };
  return (
    <div>
      <div className="container mt-5">
        <div className="text-center mb-4">
          <img src={logo} alt="logo" height={100} />
        </div>
        <div className="d-flex justify-content-center">
          <div className="col-lg-4">
            <div className="text-center mb-4">
              <Typography variant="h5" fontWeight={700}>
                Reset my password
              </Typography>
            </div>
            <form onSubmit={resetPassword}>
              <div className="mb-3">
                <TextField
                  onChange={(e) => setPassword(e.target.value)}
                  fullWidth
                  label="Password"
                  type="password"
                  error={error}
                  required
                />
              </div>
              <div className="mb-3">
                <TextField
                  onBlur={(e) => setError(password !== e.target.value)}
                  error={error}
                  helperText={error && "Passwords do not match"}
                  fullWidth
                  label="Confirm Password"
                  type="password"
                  required
                />
              </div>
              <div>
                <LoadingButton
                  type="submit"
                  variant="contained"
                  fullWidth
                  color="success"
                  loading={loading}
                  disabled={error}
                >
                  Reset Password
                </LoadingButton>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
